import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { ScrollView } from "react-native-gesture-handler";
import i18n from "i18n-js";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FloatingLabelInput from "@/components/basic/FloatingLabelInput";
import Footer from "@/components/basic/Footer";
import ModalConfirm from '@/components/basic/ModalConfirm';
import PressableElement from "@/components/basic/PressableElement";
import AvatarEdit from '@/components/media/AvatarEdit';
import useIsMounted from '@/hooks/mounted';
import { backendRequest, saveImageAsync } from "@/stores/thunks";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { switchScreen } from '@/hooks/navigate';

export let updateChilds

export default function Channel({ navigation, route }) {
    const { channel, isEdit } = route.params
    const mounted = useIsMounted()
    const dispatch = useDispatch()
    const insets = useSafeAreaInsets()

    const [showModal, setShowModal] = useState(false)
    const [showModalCancel, setShowModalCancel] = useState(false)
    const [action, setAction] = useState()
    const [deleteChannel, setDeleteChannel] = useState(false)

    const server = useSelector((state) => state.server)
    const workflows = useSelector((state) => state.workflows)

    const [wasEdit, setWasEdit] = useState(false)
    const [name, setName] = useState(channel.name)
    const [desc, setDesc] = useState(channel.description)
    const [image, setImage] = useState(channel?.channelImage?.id)
    const [actWorkflows, setActWorkflows] = useState(channel.workflows?.filter(id => id && workflows[id]) || [])
    const [actContacts, setActContacts] = useState(channel.contacts || [])
    const [orgWorkflows, setOrgWorkflows] = useState(channel.workflows || [])
    const [orgContacts, setOrgContacts] = useState(channel.contacts || [])

    const actions = [
        isEdit ? { icon: '' } : { icon: 'keyboard-arrow-left', text: 'footer.back', component: 'BACK' },
        { icon: 'home', text: 'footer.home', component: 'Home' },
        isEdit ? { icon: 'check', text: 'footer.finish', component: channel.id ? 'Channel' : 'BACK', params: { channel: channel, isEdit: false } } : (server.online ? { icon: 'edit', text: 'footer.edit', component: 'Channel', params: { channel: channel, isEdit: true } } : { icon: '' })
    ]

    const selected = async (uri) => {
        setImage(uri)
    }

    updateChilds = (contacts, workflows) => {
        if (contacts) {
            setActContacts(contacts)
            channel.contacts = contacts
            // console.log('CONTACTS', contacts, orgContacts)
        } else {
            setActWorkflows(workflows)
            channel.workflows = workflows
            // console.log('WORKFLOWS', workflows)
        }
    }

    function checkAndSave() {
        if (server.online) {
            if (deleteChannel) {
                console.log('DELETE');
                if (channel.id) {
                    dispatch(backendRequest('DELETE_CHANNEL_INLINE', '/contact/channel/' + channel.id, null, 'DELETE', false));
                }
            } else {
                // without a name the channel is not saved
                if (name && name != '') {
                    const addContacts = actContacts.filter(contact => !orgContacts.includes(contact));
                    const delContacts = orgContacts.filter(contact => !actContacts.includes(contact));
                    const addWorkflows = actWorkflows.filter(workflow => !orgWorkflows.includes(workflow));
                    const delWorkflows = orgWorkflows.filter(workflow => !actWorkflows.includes(workflow));
                    if (image != channel?.channelImage?.id || name != channel.name || desc != channel.description || addContacts.length + delContacts.length + addWorkflows.length + delWorkflows.length > 0) {
                        const data = {
                            name: name.trim(),
                            description: desc?.trim(),
                            contacts: actContacts,
                            workflows: actWorkflows.map(id => workflows[id].workflowId)
                        }
                        console.log('SAVE', data)
                        dispatch(backendRequest('UPDATE_CHANNEL_INLINE', channel.id ? '/contact/channel/' + channel.id : '/contact/channel', data, channel.id ? 'PUT' : 'POST', false)).then(contacts => {
                            console.log("NEW", contacts.result);
                            if (image && typeof image != 'number' && image.startsWith('file:///') && contacts.result) {
                                dispatch(saveImageAsync('UPDATE_IMAGE_INLINE', '/contact/channel/' + contacts.result.id + '/image', { uri: image, description: name }));
                            }
                        });
                        return true
                    }
                }
            }
        }
        return false
    }

    useEffect(() => {
        navigation.setOptions({ title: i18n.t(isEdit ? (channel.id ? 'channel.update' : 'channel.create') : 'channel.title'), info: name })
    }, [name, isEdit])

    useEffect(() => {
        if (wasEdit) {
            if (checkAndSave()) {
                setOrgContacts(actContacts)
                setOrgWorkflows(actWorkflows)
            }
        }
        setWasEdit(isEdit)
    }, [isEdit])

    useEffect(
        () => {
            return navigation.addListener('beforeRemove', (e) => {
                // If we don't have unsaved changes, then we don't need to do anything
                if (name && name != '') {
                    return;
                }
                // Prevent default behavior of leaving the screen
                e.preventDefault()
                // Prompt the user before leaving the screen
                setAction(e.data.action)
                setShowModalCancel(true)
            })
        },
        [navigation, name]
    )

    useEffect(() => {
        return () => {
            if (!mounted()) {
                if (isEdit) {
                    checkAndSave()
                }
            }
        };
    }, [mounted])

    const closeModal = (confirmed) => {
        setShowModal(false)
        if (confirmed) {
            setDeleteChannel(true)
            switchScreen(navigation, 'ContactManagement')
        }
    }

    const closeModalCancel = (confirmed) => {
        setShowModalCancel(false)
        if (!confirmed) {
            navigation.dispatch(action)
        }
    }

    return (
        <View className="flex-1 bg-secondary-50">
            <ScrollView scrollIndicatorInsets={{ right: 1 }} contentContainerStyle={{ paddingBottom: 90 + insets.bottom }} className="flex-1 bg-secondary-50 py-3 px-3">
                <VStack space='2xl' className="flex-1">
                    <VStack space='xl' className="flex-1">
                        <AvatarEdit key={image} uri={image} selected={selected} sync={'/contact/media/' + image} isEdit={isEdit} />
                            <FloatingLabelInput label={i18n.t('channel.name')} value={name} placeholder={i18n.t('channel.name')} onChangeText={setName} h='h-[40px]' isDisabled={!isEdit} />
                            <FloatingLabelInput label={i18n.t('channel.description')} value={desc} placeholder={i18n.t('channel.description')} onChangeText={setDesc} isDisabled={!isEdit} h='h-[80px]' blurOnSubmit={true} returnKeyType='done' multiline={true} />
                    </VStack>
                    <VStack space='xl' className="flex-1 py-1">
                        <Text className="text-2xl text-secondary-900">{i18n.t('channel.contacts', { num: actContacts.length })}</Text>
                        <PressableElement mainText={i18n.t(isEdit ? 'channel.edit' : 'channel.show')} pressed={() => isEdit ? switchScreen(navigation, 'ContactsSelect', { title: name, channel: channel, isEdit: isEdit }) : switchScreen(navigation, 'Contacts', { channel: channel, isFinal: true })} />
                    </VStack>
                    <VStack space='xl' className="flex-1 py-1">
                        <Text className="text-2xl text-secondary-900">{i18n.t('channel.sharedWorkflows', { num: actWorkflows.length })}</Text>
                        <PressableElement mainText={i18n.t(isEdit ? 'channel.edit' : 'channel.show')} pressed={() => switchScreen(navigation, 'SharedWorkflows', { title: name, info: i18n.t('contact.sharedWorkflows'), channel: channel, isEdit: isEdit })} />
                    </VStack>
                    {channel.id && isEdit && <VStack space='xl' className="flex-1 py-1">
                        <Text className="text-2xl text-secondary-900">{i18n.t('channel.delete')}</Text>
                        <PressableElement mainText={i18n.t('channel.deleteChannel')} color='text-error-600' pressed={() => setShowModal(true)} />
                    </VStack>}
                </VStack>
            </ScrollView>
            <ModalConfirm showModal={showModal && server.online} closeModal={closeModal} title='channel.deleteChannel' text='channel.deleteChannelText' options={{ user: channel.name }} />
            <ModalConfirm showModal={showModalCancel && server.online} closeModal={closeModalCancel} title='channel.missing' text='channel.exit' options={{ user: channel.name }} buttonOk='channel.continue' buttonCancel='channel.cancel' />
            <Footer navigation={navigation} actions={actions} />
        </View>
    );
}